<template>
  <div>
    <span @click="noFill = false">
      <colour-picker v-model="colour" :disable="noFill"></colour-picker>
    </span>
    <div class="options">
      <a class="button is-outline" :class="{'is-primary': noFill}" @click="noFill = !noFill">{{ $t('magicboard.noFill') }}</a>
    </div>
  </div>
</template>

<script>
import ColourPicker from './ColourPicker'
import i18n from '@/i18n'

export default {
  props: ['settings'],
  components: {
    ColourPicker
  },
  data: function () {
    return {
      colour: null,
      noFill: false
    }
  },
  mounted: function () {
    this.colour = this.settings.colour
    this.noFill = this.settings.none
  },
  methods: {
    title: function () {
      return i18n.t('magicboard.colour')
    },
    update: function () {
      this.settings.colour = this.colour
      this.settings.none = this.noFill
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .modal-card-body {
    padding: 2%;
  }

  .options {
    margin: 2% auto;

    .button {
      padding: 0.5rem 1.5rem;

      @include mobile {
        padding: 0 0.75rem;
      }
    }
  }
</style>
